import { FBPage } from 'components/FbUI/Page/FBPage'
import { Outlet, useLocation } from 'react-router-dom'
import {
  FBPageHeader,
  FBPageTitle,
  FBPageTitleRow,
} from 'components/FbUI/Page/styles'

import styled from 'styled-components'
import { useMemo } from 'react'
import { Sparkles } from 'lucide-react'

const GROUP_TITLES: Record<string, React.ReactNode> = {
  company: 'Company',
  team: 'Team',
  platform: 'Platform',
  data: 'Data',
  notifications: 'Notifications',
  misc: 'Misc Settings',
  automations: 'Automations',
  outreach: 'Outreach',
  'email-integration': 'Email Integration',

  ai: (
    <span className="inline-flex items-center gap-1.5">
      <Sparkles size={20} />
      AI Agents
    </span>
  ),
}

export function SettingsLayout() {
  const location = useLocation()

  const group = useMemo(() => {
    const segments = location.pathname.split('/')
    return segments[2] ?? 'team'
  }, [location.pathname])

  const groupTitle = GROUP_TITLES[group] ?? 'Team'
  const isAI = group === 'ai'

  if (isAI) {
    // AI page uses noContainer + full-bleed layout like the deals detail page.
    // Left sidebar has gray bg, right side is white — no surrounding gray border.
    return (
      <FBPage innerPageClassName="!p-0 h-full" noContainer>
        <div className="flex flex-1 min-h-0 h-full overflow-hidden">
          <Outlet />
        </div>
      </FBPage>
    )
  }

  return (
    <FBPage innerPageClassName="h-full">
      <CustomFBPageHeader>
        <FBPageTitleRow>
          <CustomFBPageTitle>
            Settings: <TabTitle>{groupTitle}</TabTitle>
          </CustomFBPageTitle>
        </FBPageTitleRow>
      </CustomFBPageHeader>

      <div className="flex gap-0 flex-1 min-h-0 h-full overflow-hidden">
        <Outlet />
      </div>
    </FBPage>
  )
}

const CustomFBPageHeader = styled(FBPageHeader)`
  padding: 12px 0;
`

const CustomFBPageTitle = styled(FBPageTitle)`
  font-weight: 400;
  font-size: 24px;
`

const TabTitle = styled.span`
  font-weight: bold;
  font-size: 24px;
  line-height: 28px;
  color: #101828;
  font-size: 24px;
`
